<template>
  <div>
    <div class="text-dark opacity-50 text-xl md:text-2xl text-center pb-10">Trusted by global companies</div>
    <div class="grid grid-cols-2 pl-5 pr-5 gap-10 md:pl-0 md:pr-0 md:flex justify-between items-center">
      <div><img src="@/assets/images/companies/Sprouts_Logo_4C13.png" class="mt-5 md:w-30 h-min-content"></div>
      <div><img src="@/assets/images/companies/Moglix1.png" class="mt-5 md:w-30 h-min-content"></div>
      <div><img src="@/assets/images/companies/AdityaBirla.png" class="mt-5 md:w-30 h-min-content"></div>
      <div><img src="@/assets/images/companies/zilingo2.png" class="md:w-25 h-min-content"></div>
      <div><img src="@/assets/images/companies/cii.png" class="mt-5 md:w-30 h-min-content"></div>
      <div><img src="@/assets/images/companies/BOA.png" class="mt-5 md:w-30 h-min-content"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'GlobalCompanies'
}
</script>